// src/components/communications/CommunicationsFilterBar.js
import React from 'react';
import { MagnifyingGlassIcon, AdjustmentsHorizontalIcon, EnvelopeIcon, ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/outline';

const CommunicationsFilterBar = ({
                                     searchTerm,
                                     setSearchTerm,
                                     filterStatus,
                                     setFilterStatus,
                                     availableStatuses,
                                     filterType,
                                     setFilterType,
                                     availableTypes,
                                 }) => {
    return (
        <div className="bg-white rounded-lg shadow-md p-4 flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4 mb-6">
            {/* Search Input */}
            <div className="relative w-full md:w-1/2">
                <input
                    type="text"
                    placeholder="Search by name, subject, or audience..."
                    className="w-full pl-10 pr-4 py-2 rounded-lg bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent text-gray-700"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
            </div>

            {/* Filter by Status */}
            <div className="flex items-center space-x-2 w-full md:w-auto">
                <AdjustmentsHorizontalIcon className="h-5 w-5 text-gray-500" />
                <label htmlFor="statusFilter" className="sr-only">Filter by Status</label>
                <select
                    id="statusFilter"
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent w-full"
                >
                    {availableStatuses.map(status => (
                        <option key={status} value={status}>{status}</option>
                    ))}
                </select>
            </div>

            {/* Filter by Type */}
            <div className="flex items-center space-x-2 w-full md:w-auto">
                {filterType === 'Email' ? <EnvelopeIcon className="h-5 w-5 text-gray-500" /> : <ChatBubbleBottomCenterTextIcon className="h-5 w-5 text-gray-500" />}
                <label htmlFor="typeFilter" className="sr-only">Filter by Type</label>
                <select
                    id="typeFilter"
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent w-full"
                >
                    {availableTypes.map(type => (
                        <option key={type} value={type}>{type}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default CommunicationsFilterBar;